import Button from '../components/common/Button';
import PageHero from '../components/layout/PageHero';

function CompleteTaskThankYouPage() {
  return (
    <>
      <PageHero
        eyebrow="CAREERS"
        title="Task submitted successfully."
        description="Thank you for completing the FactorStreet task round. Our hiring team will review your submission and contact you if you are shortlisted for the next stage."
      />
      <section className="section apply-thank-you-page">
        <div className="container apply-thank-you-card">
          <div>
            <p className="eyebrow">NEXT STEPS</p>
            <h2>Our hiring team has your task submission.</h2>
            <p>
              Please keep checking your inbox and spam/promotions folder for updates from FactorStreet HR.
            </p>
          </div>
          <div className="apply-thank-you-actions">
            <Button to="/hiring-process" variant="primary">
              View hiring process
            </Button>
            <Button to="/jobs" variant="secondary">
              View current openings
            </Button>
            <Button to="/" variant="secondary">
              Go home
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}

export default CompleteTaskThankYouPage;
